<template>
	<div>
		<div class="cpns-navTtile flex flex-align-center flex-jus-between" :style="{'position': fixed?'fixed':'relative'}">
			<img src="../../static/images/icon-arrowLeft.png" class="arrow" @click="goBack">
			<div class="flex-1"><slot></slot></div>
			<img src="../../static/images/icon-my.png" class="arrow" @click="$router.replace({'name': 'my'})">
		</div>
		<div class="cpns-navTtileStation" v-if="fixed"></div>
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		props:{
			fixed: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return{

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			goBack() {
				if (window.history.length <=1 ) {
					this.$router.push('/home')
				} else {
					this.$router.back(-1)
				}
			}
		}
	}
</script>

<style scoped lang="stylus">
.cpns-navTtile
	position fixed
	top 0
	width: 100%
	height: 96px;
	background: #DE113C;
	padding 22px 30px
	z-index 2000
	.arrow
		width 52px
		height 52px
.cpns-navTtileStation
	width: 100%
	height: 96px;
	background-color transparent
</style>
